import { render, staticRenderFns } from "./startTest.vue?vue&type=template&id=d3816918&scoped=true&"
import script from "./startTest.vue?vue&type=script&lang=js&"
export * from "./startTest.vue?vue&type=script&lang=js&"
import style0 from "./startTest.vue?vue&type=style&index=0&id=d3816918&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3816918",
  null
  
)

export default component.exports